import { beliefs } from "../mock";
import { BookOpen, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function WhatWeBelieve() {
  return (
    <main className="pt-32 pb-24 bg-[#faf7f2]">
      <section className="relative py-20 bg-gradient-to-b from-[#0a2d38] to-[#0e5469] text-white -mt-32">
        <div className="max-w-5xl mx-auto px-6 md:px-12 pt-24 text-center">
          <Link to="/" className="inline-flex items-center gap-2 text-[#c8a36a] hover:text-[#f0d9a8] text-sm mb-6">
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
          <div className="text-[#c8a36a] uppercase tracking-[0.32em] text-xs font-semibold mb-3">Statement of Faith</div>
          <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05]">
            What We <span className="font-script italic text-[#f0d9a8]">Believe</span>
          </h1>
          <p className="mt-6 max-w-2xl mx-auto text-white/85 leading-relaxed">
            The 16 Fundamental Truths of the Assemblies of God — the Scriptural foundation upon which our faith and ministry stand.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 md:px-12 mt-16">
        <Accordion type="single" collapsible className="space-y-3">
          {beliefs.map((b) => (
            <AccordionItem key={b.n} value={b.n} className="bg-white border border-[#e7dfd0] rounded-md px-6 data-[state=open]:border-[#c8a36a] data-[state=open]:shadow-[0_20px_40px_-30px_rgba(14,84,105,0.4)]">
              <AccordionTrigger className="hover:no-underline py-5">
                <div className="flex items-center gap-5 text-left">
                  <span className="font-serif-display text-2xl text-[#c8a36a]">{b.n}</span>
                  <span className="font-serif-display text-xl text-[#0a2d38]">{b.title}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-6">
                <div className="flex items-start gap-3 pl-12 text-[#3b4d54] leading-relaxed text-[16px]">
                  <BookOpen className="h-4 w-4 text-[#c8a36a] mt-1.5 flex-shrink-0" />
                  <p>{b.short}</p>
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-14 p-8 bg-[#f3ede0] border border-[#e7dfd0] rounded-md text-center">
          <p className="text-[#3b4d54]">Have questions about what we believe?</p>
          <a href="mailto:pastor@firstassemblylivingwaters.org" className="mt-3 inline-block btn-teal rounded-full px-6 py-3 font-semibold">
            Email Pastor Hershel
          </a>
        </div>
      </section>
    </main>
  );
}
